<!--
 * @Author: your name
 * @Date: 2021-03-02 19:05:38
 * @LastEditTime: 2025-12-30 15:18:26
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\materialList.vue
-->
<template>
  <div class="material-list">
    <div class="plug-in">
      <div v-for="tool in toolsList" :key="'tool' + tool.type" :id="$uuid.v4()" class="plug-child flex-c-c"
        :draggable="true" @dragstart="dragstart" :data-type="tool.type" :data-template="JSON.stringify(tool)"
        :data-offset="JSON.stringify(offset)" v-show="tool.type !== '1' && tool.type !== '2'">
        <!-- :id="'tool-'+index"
        :data-thumb="tool.image"-->
        <el-tooltip class="item" effect="dark" :content="$t(tool.i18nTitle)" placement="top">
          <div>
            <img class="plug-child-icon" :src="tool.image" alt />
          </div>
        </el-tooltip>
      </div>
    </div>
    <div v-loading="loading" class="media-list">
      <ul class="media-list-ul" v-infinite-scroll="loadMedia" v-if="!isSaveProgram">
        <li class="vdr-child vdr-child-load flex-c-c" @click="addMedia">{{ $t('PE.Uploaded') }}+</li>
        <li v-for="(media, index) in mediaList" :key="'media' + index" :id="$uuid.v4()" class="vdr-child"
          :draggable="true" @dragstart="dragstart" :data-type="media.type" :data-template="JSON.stringify(media)"
          :data-offset="JSON.stringify(offset)">
          <media-item :media="media"></media-item>
        </li>
        <li class="vdr-child vdr-child-load flex-c-c" @click="loadMedia" v-show="mediaList.length !== 0">
          {{ mediaList.length === current ? $t('PE.AllLoaded') : $t('PE.materialsLoaded') }}</li>
        <i v-for="index in 10" :key="index" style="width: 120px; margin: 0px 4px;"></i>
      </ul>
    </div>
  </div>
</template>

<script>
import MediaItem from '@/components/basics/MediaItem.vue'
import toolsList from './../scripts/toolsList.js';

export default {
  name: 'MaterialList',
  props: {
    mediaList: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: -1
    }
  },
  data() {
    // const toolsList = [
    //   { title: "文本", type: "4", image: "program_text.png" },
    //   { title: "数字时钟", type: "6", image: "program_numclock.png" },
    //   { title: "模拟时钟", type: "7", image: "program_imitateclock.png" },
    //   { title: "天气", type: "5", image: "program_weather.png" },
    //   { title: "正计时", type: "13", image: "program_positivetime.png" },
    //   { title: "倒计时", type: "12", image: "program_countdown.png" },
    //   { title: "流媒体", type: "14", image: "program_media.png" },
    //   { title: "RSS", type: "17", image: "program_Rss.png" },
    //   // { title: "日历", type: "11", image: "program_calendar.png" },
    // ]
    return {
      toolsList: toolsList(),
      loading: false,
      offset: {
        offsetX: 0,
        offsetY: 0,
        percentageX: 0,
        percentageY: 0
      }
    }
  },
  mounted() {
    this.toolsList.forEach((tool) => {
      tool.image && (tool.image = require("@/assets/images/program/" + tool.image));
    });
    // console.log(this.toolsList);
    if (this.$cookies.get("language") !== 'zh') {
      this.toolsList = this.toolsList.filter(t => t.type !== '5');
    }
  },
  methods: {
    dragstart(event) {
      this.offset.offsetX = event.offsetX;
      this.offset.offsetY = event.offsetY;
      this.offset.percentageX = event.offsetX / event.target.offsetWidth;
      this.offset.percentageY = event.offsetY / event.target.offsetHeight;
      this.$nextTick(() => {
        event.dataTransfer.setData("selectVdr", event.target.id);
      });
    },
    loadMedia() {
      if (this.mediaList.length === this.current) { return; }
      this.loading = true;
      this.$emit('mediaListChange');
      setTimeout(() => { this.loading = false; }, 1000);
    },
    addMedia() {
      this.$router.push({
        name: 'NewMediaList',
        query: {
          type: 'programEdit'
        }
      })
    },
  },
  components: {
    MediaItem
  },
  computed: {
    isSaveProgram() {
      return this.$store.state.program.isSaveProgram;
    }
  }
}
</script>
<style lang="scss" scoped>
.material-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(240, 240, 240, 1);
  }

  .plug-in {
    height: 60px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    margin-right: 4px;
    border-top: 1px solid #d7ecf3;
    border-left: 1px solid #d7ecf3;

    .plug-child {
      width: 50px;
      height: 50px;
      margin: 0px 4px;
      flex: none;
      user-select: none;
      cursor: move;

      .plug-child-icon {
        pointer-events: none;
      }
    }
  }

  .media-list {
    height: calc(100% - 60px);
    min-height: 180px;
    border-top: 1px solid #d7ecf3;
    border-left: 1px solid #d7ecf3;

    // align-content: space-around ;
    .media-list-ul {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow-y: auto;

      .vdr-child {
        cursor: move;
        // cursor: grab;
        // cursor: grabbing;
        width: 120px;
        height: 84px;
        background-color: #eefbff;
        margin: 4px;
        border-radius: 4px;
        overflow: hidden;
      }

      .vdr-child-load {
        cursor: pointer;
        user-select: none;
      }
    }
  }
}
</style>